import { Box, Stack, Typography } from '@mui/material';
import React, { ReactElement } from 'react';
import DateFnsAdapter from '@date-io/date-fns';
import { AppPrimaryButton } from 'shared/components/AppComponents';
import { formattingDate, formattingEpochDiff } from 'shared/helpers/FormatDate';

const dateFns = new DateFnsAdapter();

const RightMenu: React.FC<RightMenuProps> = (props): ReactElement => {
    const {
        packetStatus,
        SLADate,
        clientName,
        bin,
        loanNumber,
        uploadedDate,
        packetType,
        operatorId,
        reason,
        confirmUploaded,
        actionOnSubmit,
        isLoading,
    } = props;

    return (
        <Box className="menu-wrapper">
            <Box className="menu-container">
                <Stack direction="column" className="menu">
                    <Box className="menu-content row">
                        <Typography variant="h4">Cross Check Status</Typography>
                        <Typography>{packetStatus}</Typography>
                    </Box>

                    <Box className="menu-content content-reason">
                        <Typography variant="h4">Reason</Typography>
                        <Typography component="span">{reason}</Typography>
                    </Box>
                    <Box className="menu-content row">
                        <Typography variant="h4">SLA</Typography>
                        <Typography>
                            {formattingEpochDiff(SLADate.toISOString())}
                        </Typography>
                    </Box>
                    <Box className="menu-content row">
                        <Typography variant="h4">Checklist</Typography>
                        <Typography>{clientName}</Typography>
                    </Box>
                    <Box className="menu-content row">
                        <Typography variant="h4">Reference Number</Typography>
                        <Typography>{bin}</Typography>
                    </Box>
                    <Box className="menu-content row">
                        <Typography variant="h4">Application Number</Typography>
                        <Typography>{loanNumber}</Typography>
                    </Box>
                    <Box className="menu-content row">
                        <Typography variant="h4">Uploaded</Typography>
                        <Typography>{`${formattingDate(
                            uploadedDate.toISOString()
                        )}`}</Typography>
                    </Box>
                    <Box className="menu-content row">
                        <Typography variant="h4">Uploaded Age</Typography>
                        <Typography>{`${dateFns.getDiff(
                            new Date(),
                            uploadedDate,
                            'days'
                        )} days ago`}</Typography>
                    </Box>
                    <Box className="menu-content row">
                        <Typography variant="h4">Cross Check Type</Typography>
                        <Typography className="packettype">
                            {packetType}
                        </Typography>
                    </Box>
                    <Box className="menu-content row">
                        <Typography variant="h4">Member ID</Typography>
                        <Typography>{operatorId}</Typography>
                    </Box>
                </Stack>
            </Box>
            <Box className="menu-footer">
                <AppPrimaryButton
                    title="Save & Exit"
                    isLoading={isLoading}
                    loadingSize={22}
                    loadingText="PROCESSING"
                    className="btn-small download"
                    onClick={actionOnSubmit}
                    disabled={!confirmUploaded || isLoading}
                />
            </Box>
        </Box>
    );
};

export default RightMenu;
